import { type Locale } from '@ardoq/locale';
import { TraversalBuilderState, TripleOption, TripleOptions } from '../types';
import { sortByKey } from './createOptions';

export const filterOptions = (
  options: TripleOption[],
  filterTermLower: string,
  showOnlyOptionsWithInstanceCounts: boolean
) =>
  options
    .filter(
      ({ instanceCounts }) =>
        !showOnlyOptionsWithInstanceCounts ||
        instanceCounts === null ||
        instanceCounts > 0
    )
    .filter(
      ({
        metaDataComponent: { label },
        metaDataReference: { representationData },
      }) =>
        label.toLowerCase().includes(filterTermLower) ||
        !representationData ||
        representationData.displayLabel.toLowerCase().includes(filterTermLower)
    );

export const tripleOptionToFilteredAndSortedTripleOptions = (
  tripleOptions: TripleOptions,
  triplesSortAndFiltersState: TraversalBuilderState['triplesSortAndFiltersState'],
  locale: Locale
) => ({
  ...tripleOptions,
  outgoing: filterOptions(
    tripleOptions.outgoing,
    triplesSortAndFiltersState.filterTerm.toLowerCase(),
    triplesSortAndFiltersState.showOnlyOptionsWithInstanceCounts
  ).sort(sortByKey(triplesSortAndFiltersState.tripleSortOrder, locale)),
  incoming: filterOptions(
    tripleOptions.incoming,
    triplesSortAndFiltersState.filterTerm.toLowerCase(),
    triplesSortAndFiltersState.showOnlyOptionsWithInstanceCounts
  ).sort(sortByKey(triplesSortAndFiltersState.tripleSortOrder, locale)),
});

export const getHasTripleOptions = (
  tripleOptions: TripleOptions,
  triplesSortAndFiltersState: TraversalBuilderState['triplesSortAndFiltersState']
) => {
  return {
    outgoingReferences:
      tripleOptions.outgoing.length > 0 &&
      (!triplesSortAndFiltersState.showOnlyOptionsWithInstanceCounts ||
        tripleOptions.outgoing.some(
          ({ instanceCounts }) => instanceCounts === null || instanceCounts > 0
        )),
    incomingReferences:
      tripleOptions.incoming.length > 0 &&
      (!triplesSortAndFiltersState.showOnlyOptionsWithInstanceCounts ||
        tripleOptions.incoming.some(
          ({ instanceCounts }) => instanceCounts === null || instanceCounts > 0
        )),
  };
};
